import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import WhatsAppWidget from "./components/WhatsApp/WhatsAppWidget";
import NotificationList from "./components/NotificationList";
import AdminLogin from "./features/admin/Login/AdminLogin";
import ManageCustomer from "./features/admin/manage/ManageCustomer";
import SetPassword from "./components/Staff/SetPassword";
import Dashboard from "./features/admin/components/Dashboard";
import AdminDashboard from "./features/admin/components/AdminDashboard";
import AdminProfile from "./features/admin/components/AdminProfile";
import AdminApproval from "./features/admin/components/AdminApproval";
import AdminUsers from "./features/admin/components/AdminUsers";
import CustomerDetails from "./features/admin/Details/CustomerDetails";
import TicketDetails from "./features/admin/Details/TicketDetails";
import DetailedTicket from "./features/admin/Details/DetailedTicket";
import TickerResponse from "./features/admin/components/TicketResponse";
import ServiceDetails from "./features/admin/Details/ServiceDetails";
import BookingForm from "./features/booking/components/BookingForm";
import BookingFinal from "./features/booking/components/BookingFinal";
import BookingCustomer from "./features/admin/manage/BookingCustomer";
import PaymentSuccess from "./pages/PaymentSuccess/PaymentSuccess";
import BookingSuccess from "./pages/BookingSuccess/BookingSuccess";
import WaitingForPayment from "./features/payment/Payment/WaitingForPayment";
import ForgotPassword from "./features/admin/components/ForgotPassword";
import ResetPasswordAdmin from "./features/admin/components/ResetPasswordAdmin";
import AdminInvoiceList from "./features/admin/components/AdminInvoiceList";
import BookingReceipts from "./features/admin/components/BookingReceipts";
import Footer from "./components/layout/Footer/Footer";
import BigCommerceInvoiceLists from "./features/admin/components/BigCommerceInvoiceLists";
import SendInvite from "./features/admin/components/SendInvite";
import BigCommerceInvoiceEditPage from "./features/superadmin/BigCommerceInvoiceEditPage";
import AddRacketPurchases from "./features/admin/components/AddRacketPurchases";
import OurServices from "./features/booking/Services/OurServices";
import GripBookingForm from "./features/booking/Grip/GripBooking/GripBookingForm";
import GripBookingDetails from "./features/booking/Grip/GripBooking/GripBookingDetails";
import GripBookingFinal from "./features/booking/Grip/GripBooking/GripBookingFinal";
import GripPaymentSuccess from "./pages/GripPaymentSuccess/GripPaymentSuccess";
import StringerDashboard from "./features/stringer/StringerDashboard";
import StringerInventory from "./features/stringer/StringerInventory";
import StringerServiceForm from "./features/stringer/StringerServiceForm";
import AnalyticsDashboard from "./features/stringer/AnalyticsDashboard";
import FreeServiceManagement from "./features/admin/manage/FreeServiceManagement";
import StringingDiscounts from "./features/admin/components/StringingDiscounts";
import ExpressSettingsPage from "./features/admin/components/ExpressSettingsPage";
import ActiveStringing from "./features/admin/manage/ActiveStringing";

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const App = () => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
      <Router basename="/">
        <div>
          <Routes>
            <Route path="/admin-dashboard/*" element={<Navigate to="/" replace />} />
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/" element={<AdminLogin />} />
            <Route path="/notifications" element={<NotificationList />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPasswordAdmin />} />
            <Route path="/dashboard" element={<AdminDashboard />}>
              <Route index element={<Dashboard />} />
              <Route path="manage-customer" element={<ManageCustomer />} />
              <Route path="booking-customer" element={<BookingCustomer />} />
              <Route
                path="/dashboard/bigcommerce-invoices"
                element={<BigCommerceInvoiceLists />}
              />
              <Route path="/dashboard/send-invite" element={<SendInvite />} />
              <Route path="profile" element={<AdminProfile />} />
              <Route path="customer-details" element={<CustomerDetails />} />
              <Route
                path="add-purchases/:customerId"
                element={<AddRacketPurchases />}
              />
              <Route path="ticket-details" element={<TicketDetails />} />
              <Route
                path="detailed-ticket/:ticketId"
                element={<DetailedTicket />}
              />
              <Route path="ticket-response" element={<TickerResponse />} />
              <Route
                path="customer/service-details/:customerId"
                element={<ServiceDetails />}
              />
              <Route path="booking-form" element={<BookingForm />} />
              <Route path="booking-final" element={<BookingFinal />} />
              <Route path="manage-invoices" element={<AdminInvoiceList />} />
              <Route path="booking-receipts" element={<BookingReceipts />} />
              <Route path="our-services/:customerId" element={<OurServices />} />
              <Route path="grip-booking-form" element={<GripBookingForm />} />
              <Route path="grip-booking-details" element={<GripBookingDetails />} />
              <Route path="grip-booking-final" element={<GripBookingFinal />} />
              <Route path="stringer-dashboard" element={<StringerDashboard />} />
              <Route path="active-stringing" element={<ActiveStringing />} />
              <Route path="stringer-inventory" element={<StringerInventory />} />
              <Route path="stringer-service" element={<StringerServiceForm />} />
              <Route path="free-service-management" element={<FreeServiceManagement />} />
              <Route path="stringing-discounts" element={<StringingDiscounts />} />
              <Route path="express-settings" element={<ExpressSettingsPage />} />
              <Route path="admin-users" element={<AdminUsers />} />
            </Route>
            <Route
              path="superadmin/bigcommerce-invoices/:invoiceId"
              element={<BigCommerceInvoiceEditPage />}
            />
            <Route path="/pending-requests" element={<AdminApproval />} />
            {/* <Route path="/dashboard/stringer-dashboard" element={<StringerDashboard />} /> */}

            <Route path="/admin/set-password" element={<SetPassword />} />
            <Route path="/analytics-dashboard" element={<AnalyticsDashboard />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/grip-payment-success" element={<GripPaymentSuccess />} />
            <Route path="/booking-success" element={<BookingSuccess />} />
            <Route
              path="/waiting-for-payment"
              element={<WaitingForPayment />}
            />
          </Routes>
          <WhatsAppWidget />
          <Footer />
        </div>
      </Router>
    </GoogleReCaptchaProvider>
  );
};

export default App;
